import React from 'react'
import { ethers } from 'ethers'
import { useEffect, useState } from 'react'
import axios from 'axios'
import Web3Modal from "web3modal"

import {
    marketplaceAddress
} from '../../config'


import NFTMarketplace  from '../../utils/ropston/NFTMarketplace.json'
import Countdown from 'react-countdown';
import a1 from "../im/ava.png"
import item1 from '../im/items/featured-item-1.png';
import item2 from '../im/items/featured-item-2.png';
import item3 from '../im/items/featured-item-3.png';
import item4 from '../im/items/featured-item-4.png';
import item5 from '../im/items/featured-item-5.png';
import item6 from '../im/items/featured-item-6.png';
import item7 from '../im/items/featured-item-7.png';
import item8 from '../im/items/featured-item-8.png';
import item9 from '../im/items/featured-item-9.png';
import item10 from '../im/items/featured-item-10.png';
import item11 from '../im/items/featured-item-11.png';
import item12 from '../im/items/featured-item-12.png';
import item13 from '../im/items/featured-item-13.png';
import item14 from '../im/items/featured-item-14.png';
import item15 from '../im/items/featured-item-15.png';
import item16 from '../im/items/featured-item-16.png';
import item17 from '../im/items/featured-item-17.png';
import item18 from '../im/items/featured-item-18.png';
import item19 from '../im/items/featured-item-19.png';
import item20 from '../im/items/featured-item-20.png';
import item21 from '../im/items/featured-item-21.png';
import item22 from '../im/items/featured-item-22.png';
import item23 from '../im/items/featured-item-23.png';
import item24 from '../im/items/featured-item-24.png';


import a2 from '../im/avatarr/avatar-2.png';
import a3 from '../im/avatarr/avatar-3.png';
import a4 from '../im/avatarr/avatar-4.png';
import a5 from '../im/avatarr/avatar-5.png';
import a6 from '../im/avatarr/avatar-6.png';
import a7 from '../im/avatarr/avatar-7.png';
import a8 from '../im/avatarr/avatar-8.png';
import a9 from '../im/avatarr/avatar-9.png';
import a10 from '../im/avatarr/avatar-10.png';
import a11 from '../im/avatarr/avatar-11.png';
import a12 from '../im/avatarr/avatar-12.png';
import a13 from '../im/avatarr/avatar-13.png';
import a14 from '../im/avatarr/avatar-14.png';
import a15 from '../im/avatarr/avatar-15.png';

function Newest_item() {
    const [nfts, setNfts] = useState([])
    const [loadingState, setLoadingState] = useState('not-loaded')
    useEffect(() => {
        loadNFTs()
    }, [])
    async function loadNFTs() {
        /* create a generic provider and query for unsold market items */
        // const provider = new ethers.providers.JsonRpcProvider('https://ropsten.infura.io/v3/c1e1ec09acaf40dead35d6ea8af26736')
        const provider = new ethers.providers.JsonRpcProvider('https://ropsten.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161')



        const contract = new ethers.Contract(marketplaceAddress, NFTMarketplace.abi, provider)
        const data = await contract.fetchMarketItems()
    
        /*
        *  map over items returned from smart contract and format 
        *  them as well as fetch their token metadata
        */
        const items = await Promise.all(data.map(async i => {
          const tokenUri = await contract.tokenURI(i.tokenId)
          const meta = await axios.get(tokenUri)
          let price = ethers.utils.formatUnits(i.price.toString(), 'ether')
          let item = {
            price,
            tokenId: i.tokenId.toNumber(),
            seller: i.seller,
            owner: i.owner,
            image: meta.data.image,
            name: meta.data.name,
            description: meta.data.description,
          }
          return item
        }))
        setNfts(items)
        setLoadingState('loaded') 
      }
      async function buyNft(nft) {
        /* needs the user to sign the transaction, so will use Web3Provider and sign it */
        const web3Modal = new Web3Modal()
        const connection = await web3Modal.connect()
        const provider = new ethers.providers.Web3Provider(connection)
        const signer = provider.getSigner()
        const contract = new ethers.Contract(marketplaceAddress, NFTMarketplace.abi, signer)
    
        /* user will be prompted to pay the asking proces to complete the transaction */
        const price = ethers.utils.parseUnits(nft.price.toString(), 'ether')   
        const transaction = await contract.createMarketSale(nft.tokenId, {
          value: price
        })
        await transaction.wait()
        loadNFTs()
      }
      if (loadingState === 'loaded' && !nfts.length) return (<h1 className="px-20 py-10 text-3xl">No items in marketplace</h1>)
    return (
        <div>
            <h1 className='display-5 fw-bolder headd  p-5'><span className='text-primary'>New</span><span className='text-info'>est</span> <span className='text-light'>Items</span></h1>
            {/* cards start here */}
            <div className='p-4'>

                {/*--------------------------------- card1 ------------------------------------*/}
                <div className=' col-lg-3 col-sm-1 col-md-6 d-inline-block p-3'>

                    {nfts.map((nft,i) => {
                        return(
                            <div className=''>

                        <div className=' bg-dark  border border-muted rounded-9 '>


                            <div className='card    rounded-9 bggtimer '>
                                <div className='card   border border-muted rounded-9 bggtimer'>

                                    <img src={nft.image} className='rounded-9 p-3'></img>

                                    <div className='bg-dark col-sm-12 col-lg-6 col-md-8 mx-auto rounded-9 car-tim  hover-overlay  border border-muted'>
                                        <a ><h6 className='my-auto  text-light '> <i class="fas fa-clock p-2"></i> <Countdown date={Date.now() + 550000000}></Countdown></h6></a>
                                        {/* hover function for countdown */}
                                        <div class="mask  rounded-9 bgbtt-gra">
                                            <a ><h6 className='my-auto  text-light'><i class="fas fa-clock p-2"></i><Countdown date={Date.now() + 550000000}></Countdown></h6></a>

                                        </div>
                                    </div>


                                    <h5 className=' fw-bolder mx-3 text-light'>{nft.name}</h5>
                                    <p className=' fw-bolder mx-3 text-light'>{nft.description}</p>



                                    <div className=' p-3'> <img class="avatar avatar-32 bg-primary rounded-circle text-white p-1"
                                        src={a1} /><a href="">

                                            <span class="badge rounded-pill new-items-badge bg-primary mt-3"><i class="ni-tick fas fa-check"></i>  </span>
                                            <span className='fw-bolder mx-3'> @{nft.seller}</span>
                                        </a>
                                    </div>

                                </div>
                                <span class="badge rounded-pill likes-button bg-dark mt-3  p-3 align-self-end  hover-overlay border border-muted">
                                    <p className="like-btn-icon">
                                        <i class=" fas fa-heart"></i> 60
                                    </p>
                                </span>

                            </div>
                            <div className='container'>
                                <div className='row mt-3 fw-bold text-light'>
                                    <div className='col-6'>
                                        <h6>RESERVE PRICE</h6>
                                        <h5>{nft.price}</h5>

                                    </div>
                                    <div className='col-6'>
                                        <h6>SHARE</h6>
                                        <h6><i class="fab fa-facebook-square "><i class="fab fa-twitter mx-3"></i></i><i class="fab fa-instagram"></i></h6>

                                    </div>

                                </div>

                            </div>






                        </div>

                    </div>
                        )
                    })}
                    
                </div>

            </div>
  
            <div class=" text-center ">

         

            <a href="/"><button className="bnn632-hover bn19">View All Artwork</button></a>

          
 
  </div>






        </div>
    )
}

export default Newest_item
